import React, {useEffect, useState} from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import {fetchDeployedVersion, getRunningVersion} from "../../Service/AppVersion";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Aucun rechargement automatique : il couperait un opérateur en plein glisser ou en plein dépôt de fichier.
export default function NewVersionBanner() {
    const [deployedVersion, setDeployedVersion] = useState(null)

    useEffect(() => {
        const runningVersion = getRunningVersion()
        if (!runningVersion) {
            return
        }

        const check = () => {
            fetchDeployedVersion()
                .then(version => {
                    if (version && version !== runningVersion) {
                        setDeployedVersion(version)
                    }
                })
                .catch(() => {})
        }

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                check()
            }
        }

        const timer = setInterval(check, CHECK_INTERVAL_MS)
        document.addEventListener("visibilitychange", handleVisibilityChange)

        return () => {
            clearInterval(timer)
            document.removeEventListener("visibilitychange", handleVisibilityChange)
        }
    }, []);

    return (
        <Snackbar open={Boolean(deployedVersion)} anchorOrigin={{vertical: "bottom", horizontal: "left"}}>
            <Alert
                severity="info"
                variant="filled"
                sx={{alignItems: "center"}}
                action={
                    <Button color="inherit" size="large" onClick={() => window.location.reload()} sx={{minHeight: 44}}>
                        Recharger
                    </Button>
                }
            >
                Une nouvelle version de l'écran est disponible
            </Alert>
        </Snackbar>
    )
}
